<template>
  <div>
    <div class="columns nav-padding-fix">
      <div class="column is-7">
        <h1 class="title is-3">Gebruiker</h1>

        <div class="field">
          <label class="label">Email</label>
          <div class="control">
            <input class="input" type="email" v-model="email" required>
          </div>
        </div>

        <div class="field" v-if="isNew">
          <label class="label">Wachtwoord</label>
          <div class="control">
            <input class="input" type="password" v-model="password" required>
          </div>
        </div>

        <div class="columns no-margin-bottom">
          <div class="column">
            <div class="field">
              <label class="label">Voornaam</label>
              <div class="control">
                <input class="input" type="text" v-model="firstName" required>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Achternaam</label>
              <div class="control">
                <input class="input" type="text" v-model="lastName" required>
              </div>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">Rechten</label>
          <div class="control">
            <div class="select full-width">
              <select class="full-width" v-model="permissions">
                <option value="10">Editor</option>
                <option value="20">Admin</option>
                <option value="30">Owner</option>
              </select>
            </div>
          </div>
        </div>


        <div v-if="!isNew">
          <hr>

          <div class="field">
            <label class="label">Nieuw wachtwoord</label>
            <div class="control">
              <input class="input" type="password" v-model="newPassword">
            </div>
          </div>

          <div class="button is-warning" @click="changePassword">Wachtwoord opslaan</div>

          <hr>
        </div>

        <div class="button is-primary" @click="save">Opslaan</div>
        <div class="button is-danger" v-if="!isNew" @click="remove">Verwijderen</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'users'
    ])
  },
  data () {
    return {
      id: null,
      email: null,
      password: null,
      newPassword: null,
      firstName: null,
      lastName: null,
      permissions: 10,
      isNew: true
    }
  },
  created () {
    const id = this.$route.params.id

    if (id) {
      this.getDetailsUser()
      this.isNew = false
      this.id = id
    }
  },
  methods: {
    async getDetailsUser () {
      await this.$store.dispatch('getUser', this.id)
      let user = {}

      for (let object of this.users) {
        if (object.id === this.id) {
          user = object
        }
      }

      this.email = user.email
      this.firstName = user.firstName
      this.lastName = user.lastName
      this.permissions = user.permissions
    },
    async save () {
      const { id, email, password, firstName, lastName, permissions } = this
      this.$router.push({ name: 'settings.users' })

      if (this.isNew) {
        await this.$store.dispatch('createUser', {
          email,
          password,
          firstName,
          lastName,
          permissions
        })

        return
      }

      await this.$store.dispatch('updateUserDetails', {
        id,
        email,
        firstName,
        lastName,
        permissions
      })
    },
    async changePassword () {
      await this.$store.dispatch('changePassword', {
        user: this.id,
        password: this.newPassword
      })

      this.$router.push({ name: 'settings.users' })
    },
    async remove () {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/users/edit.vue